__turbopack_context__.v({
  "className": "plus_jakarta_sans_e3c65481-module__1_OHqq__className",
  "variable": "plus_jakarta_sans_e3c65481-module__1_OHqq__variable",
});
